
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { DriverOverviewPage } from './drivers/DriverOverviewPage';
import { DriverApplicationsPage } from './drivers/DriverApplicationsPage';
import { DriverVerificationPage } from './drivers/DriverVerificationPage';
import { DriverPerformancePage } from './drivers/DriverPerformancePage';
import { DriverDocumentsPage } from './drivers/DriverDocumentsPage';

export function DriverPage() {
  return (
    <Layout>
      <Routes>
        <Route index element={<DriverOverviewPage />} />
        <Route path="applications" element={<DriverApplicationsPage />} />
        <Route path="verification" element={<DriverVerificationPage />} />
        <Route path="performance" element={<DriverPerformancePage />} />
        <Route path="documents" element={<DriverDocumentsPage />} />
        <Route path="*" element={<Navigate to="/drivers" replace />} />
      </Routes>
    </Layout>
  );
}
